<app-load-general [load]="isLoading"></app-load-general>
<div class="lg:p-0 p-3">
  <div class="flex flex-col 2xl:w-[95%] gap-4 lg:py-4 m-auto w-full">
    <div class="text-general-title px-3">Tu Tienda</div>
    <div>
      @if (mobile) {
        <div class="w-full">
          <div class="mx-4 flex gap-4 justify-end items-center">
            <app-input-general-select
              class="w-full"
              [label]="''"
              [formControlGeneral]="address"
              [arrayData]="locationDetailArray"
              [inputSelect]="{ value: '', description: 'BusinessName' }"
            ></app-input-general-select>
          </div>
        </div>
      }

      <div
        class="gap-4 flex justify-around! general-box"
        [ngClass]="{ ' flex-row! ': !mobile, 'flex flex-col! gap-1': mobile }"
      >
        <div class="flex flex-col gap-3">
          <div class="px-1 mx-auto flex justify-between items-center">
            <div class="px-1 sm:px-2 flex flex-col gap-1 py:4">
              <div class="text-(--color-text-primary) font-semibold text-2xl"></div>
              <div class="text-(--color-text-primary) text-lg font-light"></div>
            </div>
          </div>

          <div class="mx-auto flex flex-col gap-2 lg:px-1 px-3">
            <div class="text-general-title">Mis Direcciones</div>

            <div class="flex justify-between gap-4 flex-col lg:flex-row">
              <div class="flex flex-col gap-2">
                <div class="text-general-subtitle">Dirección principal</div>
                <div class="text-general">
                  {{ locationDetail?.Address || 'Dirección no disponible' }}
                </div>

                @if (!mobile) {
                  <div class="py-8 flex flex-col gap-4">
                    <button
                      (click)="openCloseTicketDetail()"
                      class="button-general-border shrink-0 w-3/4 h-11! m-auto"
                      matButton="filled"
                    >
                      Pedidos Entregados
                    </button>
                  </div>
                }
              </div>

              <div class="flex flex-col gap-2 p-2">
                <div class="text-general-subtitle">
                  Tienes {{ getTotalAmount() }} articulos en tu carrito
                </div>
                <div class="text-general flex flex-col gap-2">
                  @for (product of getproductInCarList(); track product.Id) {
                    <div>{{ $index + 1 }}: {{ product.Description }}</div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-(--M-color-bg) w-2 rounded-4xl lg:flex hidden"></div>
        @if (openTicketDetail) {
          <div class="flex flex-col gap-2 px-1">
            <div class="text-general-title px-3">Pedido Realizado</div>

            <app-expancion-card
              [ticketPendingSupply]="ticketPendingSupply"
              (openMapEvent)="openMap()"
              [mobile]="mobile"
              [viewMap]="true"
              [folio]="openTicketDetail?.Key || ''"
            >
            </app-expancion-card>
            @if (mobile && openTicketDetail.Task.Description === 'Entrega Magnum') {
              <div class="flex justify-center items-center gap-6 m-auto">
                <button
                  (click)="openMap()"
                  class="button-general-border shrink-0 h-11! w-50 py-4"
                  matButton="filled"
                >
                  Ver Mapa
                </button>

                <img
                  alt="repartidor"
                  class="w-10 h-10"
                  src="assets/icons/icon_repartidor_verde.svg"
                />
              </div>
            }
          </div>
        }
      </div>
    </div>

    @if (mobile) {
      <div class="py-8 flex flex-col gap-4">
        <button
          (click)="openCloseTicketDetail()"
          class="button-general-border shrink-0 w-3/4 h-11! m-auto"
          matButton="filled"
        >
          Pedidos Entregados
        </button>

        <button
          (click)="logout()"
          class="button-general-border shrink-0 w-3/4 h-11! m-auto"
          matButton="filled"
        >
          Cerrar Sesión
        </button>
      </div>
    }
  </div>
</div>
